/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationChooser/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Location from './Location/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LocationChooser({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsSettings/LocationChooser"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="LocationChooser.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-ZrfOYm': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Settings for"
 marginRight={dtSpaceS}
 weight="medium"
 size="xmedium"
/>
<Location
  viewPath={`${viewPath}/Location`}
/>
</div>
{children}
</React.Fragment>)
}